import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section aria-labelledby="faq-title" className="bg-cream" data-id="element-57" data-mp="1geimufhsgv0a">
      <div className="mx-auto max-w-3xl px-5 py-20 sm:px-8 lg:py-28" data-id="element-58" data-mp="2e0pn5d72816u">
        <SectionHeading id="faq-title" title="Questions fréquentes" data-id="element-59" data-mp="291mjnx6qa30z" />
        <ul className="mt-12 divide-y divide-cream-line border-y border-cream-line" data-id="element-60" data-mp="28za4tsw9o8s5">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.question} data-id="element-61" data-mp="1z2nkd57urjqn" data-mpi={i}>
                <h3 data-id="element-62" data-mp="sn3fg8b5nni6">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-5 text-left text-lg font-bold text-navy focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral" data-id="element-63" data-mp="snmo0yex0zjj">
                    {f.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-coral transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-64" data-mp="kil7gfbdvuht" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-65" data-mp="bjzr8qtdwrk7">
                  {isOpen && <motion.div id={`faq-${i}`} initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-66" data-mp="3swjyd2ji0pog">
                      <div className="space-y-3 pb-6 pr-10 leading-relaxed text-ink-soft" data-id="element-67" data-mp="1ppmdn1f1csdx">
                        {f.answer.split('\n\n').map(para => <p key={para} data-id="element-68" data-mp="1koyo6k6ggjlt">{para}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}